module.exports = {
  news: 'aktualnosci',
  about: 'o-nas',
  gallery: 'galeria',
  offer: 'oferta',
  contact: 'kontakt',
  success: 'sukces',
};
